import { SelectedGender } from "../../models/SelectedGender";
import { MapPoint } from "../../service/MapPoint"

function provideLegendHeight(width: number): number {
  if (width < 1150)
    return width / 20;
  else {
    return width / 30;
  }
}

function providePadding(width: number): number {
  if(width < 850){
    return 10;
  }

  return 120;
}


function provideLegenPadding(width: number): number {
  if(width < 1150){
    return 20;
  }

  return 50;
}

/**
 * Renvoie le nombre de données numériques disponibles
 * @param data le jeu de données avec des valeurs potentiellement vides
 * @returns le nombre d'item dont la valeur parsée en nombre n'est pas un NaN
 */
function getAvailableDataCount(data: any[]): number {
  return data
    .filter(item => !Number.isNaN(Number.parseFloat(item.esperance_de_vie)))
    .length;
}

function provideCopyrightTranslate(width:number):string{
  if(width/20>40){
  return('translate('
  +((width-providePadding(width)-provideLegenPadding(width)+10))+
  ','
  + (((width)/2)-100)+') rotate(-90)')
  }
  else{
    return('translate('
  +((width-providePadding(width)-80))+
  ','
  + (((width/2)-30)+')'))
  }
}

/**
 * Arrondit un nombre à son pas le plus proche
 * @param value nombre à arrondir
 * @param step pas d'arrondissement (ne peut pas être 0)
 * @returns le nombre arrondi
 */
function round(value: number, step: number) {
  // Gestion d'un step qui aurait été fixé à 0 en changeant la valeur pour 1
  if (step === 0) {
    step = 1.0;
  }
  var inv = 1.0 / step;
  return Math.round(value * inv) / inv;
}

// Coordonnées géographiques pour centrer la carte sur l'Europe
function EuropemapCenter(width:number):[number,number]{
  // if(width<450){
  //   return [2.548065,51.201464]
  // } else 
  return [18.58913191,54.69832972];
}

// Coordonnées géographiques pour centrer la carte sur la France
function FrancemapCenter(width:number):[number,number]{
  // if(width<450){
  //   return [2.471404,45.459141]
  // } else 
  return [2.454071, 46.279229]
}

function isFloat(value: string): boolean{
	if (value.indexOf('.') !== -1 || value.toString().indexOf(',') !== -1 )
	{
		return true
	}
	
	return false;
}

function isNumeric(str: string): boolean {
  if (typeof str != "string") {
    return false;
  }

  return !isNaN(parseFloat(str));
}

function sortDataByEvda(data:any[]):any[]{
  var sortedData:any[]=data.slice();
  sortedData.sort((n1:any,n2:any)=>{
    if (!isNumeric(n1.esperance_de_vie)) {
      return -1;
    }
    if (!isNumeric(n2.esperance_de_vie)) {
      return 1;
    }
    if (parseFloat(n1.esperance_de_vie) > parseFloat(n2.esperance_de_vie)) {
      return 1;
    }
    if (parseFloat(n1.esperance_de_vie) < parseFloat(n2.esperance_de_vie)) {
      return -1
    }

    return 0;
 });
 return sortedData;
}

function getZoneQuantileGraduation(data : MapPoint[]) : number[] {
  const itemsWithData = data
    .filter(x => x.rang >= 0)
    .sort((a, b) => a > b ? 1 : a < b ? -1 : 0);

  let n=Math.round(itemsWithData.length/5)
  let ev1 = parseFloat(itemsWithData[n].esperance_de_vie);
  let ev2 = parseFloat(itemsWithData[2*n].esperance_de_vie);
  let ev3 = parseFloat(itemsWithData[3*n].esperance_de_vie);
  let ev4 = parseFloat(itemsWithData[4*n].esperance_de_vie);

  return [ev1,ev2,ev3,ev4]  
}

function getGraduationClass(data: any[], evda: number): string {
  const graduations: number[] = getZoneQuantileGraduation(data);

  if (evda > graduations[3]){
    return "4";
  }
  if (evda > graduations[2] && evda <= graduations[3]) {
    return "3";
  }
  if (evda > graduations[1] && evda <= graduations[2]) {
    return "2";
  }
  if (evda > graduations[0] && evda <= graduations[1]) {
    return "1";
  }
  if (evda < graduations[0]) {
    return "0";
  }
   
  return "0";
}

// Donne le préfixe de la classe de couleur en fonction des filtres
function providePathClassName(selectedGender: SelectedGender) {
  switch(selectedGender){
    case SelectedGender.male : {
      return "male-zone q";
    }
    case SelectedGender.women : {
      return "female-zone q";
    }
    case SelectedGender.male_women_diff : {
      return "ecart-zone q";
    }
    default : {
      return "region q";
    }
  }
}

export {
  provideLegendHeight,
  getAvailableDataCount,
  providePadding,
  provideLegenPadding,
  provideCopyrightTranslate,
  round,
  isFloat,
  EuropemapCenter,
  FrancemapCenter,
  sortDataByEvda,
  getZoneQuantileGraduation,
  getGraduationClass,
  providePathClassName,
  isNumeric}